import produce from 'immer'

import * as types from 'Redux/Types/ReconciliationTypes'

const initialState = {
  fetchingTransactionData: false,
  fetchingArchiveTransactionData: false,
  updatingArchiveTransactionData: false,
}

const fetchTransactionData = (draft) => {
  draft.fetchingTransactionData = true
}

const fetchTransactionDataFailed = (draft) => {
  draft.fetchingTransactionData = false
}

const fetchTransactionDataSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingTransactionData = false
  draft.next = next
  draft.previous = previous
  draft.transactionData = data
}

const fetchArchiveTransactionData = (draft) => {
  draft.fetchingArchiveTransactionData = true
}

const fetchArchiveTransactionDataFailed = (draft) => {
  draft.fetchingArchiveTransactionData = false
}

const fetchArchiveTransactionDataSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingArchiveTransactionData = false
  draft.next = next
  draft.previous = previous
  draft.archiveTransactionData = data
}

const updateArchiveTransactionData = (draft) => {
  draft.updatingArchiveTransactionData = true
}

const updateArchiveTransactionDataFailed = (draft) => {
  draft.updatingArchiveTransactionData = false
}

const updateArchiveTransactionDataSucceeded = (draft, { data, next, previous }) => {
  draft.updatingArchiveTransactionData = false
  draft.next = next
  draft.previous = previous
  draft.updateArchiveTransactionData = data
}

const reconciliationReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.GET_TRANSACTION_DATA:
        return fetchTransactionData(draft)

      case types.GET_TRANSACTION_DATA_FAILED:
        return fetchTransactionDataFailed(draft)

      case types.GET_TRANSACTION_DATA_SUCCEEDED:
        return fetchTransactionDataSucceeded(draft, payload)

      case types.GET_ARCHIVE_TRANSACTION_DATA:
        return fetchArchiveTransactionData(draft)

      case types.GET_ARCHIVE_TRANSACTION_DATA_FAILED:
        return fetchArchiveTransactionDataFailed(draft)

      case types.GET_ARCHIVE_TRANSACTION_DATA_SUCCEEDED:
        return fetchArchiveTransactionDataSucceeded(draft, payload)

      case types.UPDATE_ARCHIVE_TRANSACTION_DATA:
        return updateArchiveTransactionData(draft)

      case types.UPDATE_ARCHIVE_TRANSACTION_DATA_FAILED:
        return updateArchiveTransactionDataFailed(draft)

      case types.UPDATE_ARCHIVE_TRANSACTION_DATA_SUCCEEDED:
        return updateArchiveTransactionDataSucceeded(draft, payload)

      // no default
    }
  })
}

export default reconciliationReducer
